var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center mb-3 align-items-center spinner"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"label":"Large Spinner","variant":_vm.variant,"type":"grow"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }